<div class="sonder-form-field" [ngClass]="classToggles">
    <div class="sonder-form-field-label">
      <div>
        <span class="sonder-form-field-label-text">{{ label }}</span>
        <span class="sonder-form-field-label-required" *ngIf="required">*</span>
      </div>
      <ul class="sonder-form-errors">
          <li *ngFor="let error of errorMessages" [@slideUp]="'in'">{{ error }}</li>
      </ul>
    </div>

    <ng-container *ngIf="breakpoint.isMobile$ | async">
      <input
        class="hidden"
        [id]="inputId"
        type="file"
        accept="image/*"
        [required]="required"
        [disabled]="disabled"
        (change)="selectedFile($event)"
        data-test="card-upload-input"
        #fileInputMobile
      >
      <iris-button
        *ngIf="!(dataUriBackground$ | async)"
        id="pendo-card-upload-mobile"
        data-test="add-image-button"
        [type]="irisButtonTypes.SECONDARY"
        [typeAttribute]="IrisButtonTypeAttributeOptions.BUTTON"
        (click)="fileInputClick(fileInputMobile)"
      >
        Add image
      </iris-button>
    </ng-container>
    <ng-container *ngIf="!(breakpoint.isMobile$ | async)">
      <iris-button
        *ngIf="!(dataUriBackground$ | async)"
        [id]="buttonId"
        [type]="irisButtonTypes.SECONDARY"
        [iconPosition]="irisButtonIconPositions.RIGHT"
        (click)="toggleDropdown()"
        data-test="add-image-button"
        [typeAttribute]="IrisButtonTypeAttributeOptions.BUTTON"
      >
        Add image
        <iris-icon
          name="arrow_drop_down"
          [color]="iconColors.BRAND1"
          [size]="iconSizes.MD"
          [usage]="iconUsageTypes.DECORATIVE"
        ></iris-icon>
      </iris-button>
      <div *ngIf="dropdownOpen && !(dataUriBackground$ | async)" class="dropdown-container">
        <div class="dropdown-border"></div>
        <input
          class="hidden"
          [id]="inputId"
          type="file"
          accept="image/*"
          [required]="required"
          [disabled]="disabled"
          (change)="selectedFile($event)"
          data-test="card-upload-input"
        >
        <label
          id="pendo-card-upload"
          class="unstyled-btn"
          [for]="inputId"
          role="button"
          (click)="fileInputClicked()"
        >Upload an image</label>
        <label
          id="pendo-card-take-photo"
          *ngIf="canWebcam$ | async"
          class="unstyled-btn"
          role="button"
          (click)="launchCam()"
        >Take a picture</label>
      </div>
    </ng-container>

    <div #wrapper *ngIf="(dataUriBackground$ | async) as previewImage" class="sonder-card-upload-wrapper" [ngClass]="stateClasses$ | async">
      <span class="uploaded-text" (click)="deletePhoto()">
        <mat-icon>delete</mat-icon>
        Delete
      </span>
      <img class="-background" [src]="previewImage">
    </div>
    <ng-content select="footer"></ng-content>
</div>

<ng-template cdkPortal #camPortal="cdkPortal">
    <div class="sonder-card-camera-wrapper">
        <sonder-form-legend>
          Be Sure To&hellip;
          <ol>
            <li>Align the card within the box.</li>
            <li>Make sure all card information is showing, and well lit.</li>
            <li>Click anywhere or press any key to take the photo.</li>
          </ol>
        </sonder-form-legend>

        <div class="-camera">
            <webcam [trigger]="camTrigger" (imageClick)="camTrigger.emit()" (imageCapture)="capturedImage($event)" (initError)="handleCamError($event)"></webcam>
            <div class="-viewfinder"></div>
        </div>
    </div>
</ng-template>
